import { render, staticRenderFns } from "./AssessmentSummaryPanel.vue?vue&type=template&id=360b5d48&scoped=true&"
import script from "./AssessmentSummaryPanel.vue?vue&type=script&lang=js&"
export * from "./AssessmentSummaryPanel.vue?vue&type=script&lang=js&"
import style0 from "./AssessmentSummaryPanel.vue?vue&type=style&index=0&id=360b5d48&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "360b5d48",
  null
  
)

export default component.exports